/* eslint new-cap: ["error", { "capIsNew": false }]*/
import {fromJS, Map} from 'immutable';
import {RestAPI} from '../util/net';
import {
  clearAllStatuses,
  markStoreLoaded,
  markStoreLoading
} from '../store/storeForStoringStatusOfStores.store';
import {navTo} from '../util/util.jsx';

const DEFAULT_STORE_NODE_VALUE = Map();

export const passwordResetReducer = (state = DEFAULT_STORE_NODE_VALUE, action) => {
  switch (action.type) {
    case 'LOAD_USER_DATA_FOR_TOKEN_COMPLETED':
      return state.set('user_data', fromJS(action.data));
    case 'LOAD_USER_DATA_FOR_TOKEN_FAILED':
      return state.set('error', action.data)
    case 'UPDATE_PASSWORD_FAILED':
      return state.set('form-error', action.data)
    default:
      return state;
  }
};

export const updatePassword = (dispatch, token, password, repeatPassword, mfaCode) => {
  dispatch({type: 'UPDATE_PASSWORD_STARTED'});
  markStoreLoading(dispatch);
  return RestAPI.post('/api/update-password', {token, password, repeatPassword, mfaCode})
    .then((response) => {
        clearAllStatuses(dispatch);
        dispatch({type: 'UPDATE_PASSWORD_COMPLETED'});
        markStoreLoaded(dispatch);
        navTo('/auth');
        return true;
      },
      (data) => {
        markStoreLoaded(dispatch);
        dispatch({type: 'UPDATE_PASSWORD_FAILED', data: data.message});
        return true;
      }
    );
};

export const loadUserData = (dispatch, token) => {
  dispatch({type: 'LOAD_USER_DATA_FOR_TOKEN'});
  return RestAPI.get('/api/token-user/' + token)
    .then((response) => {
        clearAllStatuses(dispatch);
        dispatch({type: 'LOAD_USER_DATA_FOR_TOKEN_COMPLETED', data: response});
        return true;
      },
      (data) => {
        dispatch({type: 'LOAD_USER_DATA_FOR_TOKEN_FAILED', data: data.message});
        return true;
      }
    );
};

export const resetPassword = (dispatch, email) => {
  dispatch({type: 'RESET_PASSWORD_STARTED'});
  return RestAPI.post('/api/reset-password', {email})
    .then((response) => {
        navTo('/auth');
        dispatch({type: 'RESET_PASSWORD_COMPLETED'});
        return true;
      },
      (data) => {
        dispatch({type: 'RESET_PASSWORD_FAILED', data: data.message});
        return true;
      }
    );
};

